import { type Hotels, type RoomType } from '@entities/avail'
import React, { createContext, useContext, useState } from 'react'

export interface AvailVipData {
  room: RoomType | undefined
  hotel: Hotels | undefined
  checkIn: any
  checkOut: any
}

interface AvailVipContextData {
  toggleAvailVipModal: () => void
  setData: ({ checkIn, checkOut, hotel, room }: AvailVipData) => void
  isOpen: boolean
  reservationVipData: AvailVipData | undefined
}

// eslint-disable-next-line
const AvailVipContext = createContext<AvailVipContextData>({} as AvailVipContextData);

function AvailVipProvider({
  children,
}: React.PropsWithChildren<object>): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)
  const [reservationVipData, setReservationVipData] = useState<AvailVipData>()

  function toggle(): void {
    setIsOpen(!isOpen)
  }

  function setData({ room, hotel, checkIn, checkOut }: AvailVipData): void {
    setReservationVipData({
      hotel,
      room,
      checkIn,
      checkOut,
    })
    toggle()
  }

  return (
    <AvailVipContext.Provider
      value={{
        isOpen,
        toggleAvailVipModal: toggle,
        reservationVipData,
        setData,
      }}
    >
      {children}
    </AvailVipContext.Provider>
  )
}

function useAvailVip(): AvailVipContextData {
  const context = useContext(AvailVipContext)

  if (!context) {
    throw new Error('useAvailVip must be used within an AvailVipProvider')
  }

  return context
}

export { AvailVipProvider, useAvailVip }
